import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import MuiDrawer from '@mui/material/Drawer'
import { CSSObject, styled, Theme } from '@mui/material/styles'
import { useEffect, useRef } from 'react'
import { COLORS } from '../../styles/colors'
import NotificationsContent from './components/main-content/NotificationsContent'

const drawerWidth = '410px'

const openedMixin = (theme: Theme): CSSObject => ({
	width: drawerWidth,
	marginLeft: 220,
	zIndex: 999,
	background: 'transparent',
	borderRadius: '0 12px 12px 0',
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: 300,
	}),
	overflowX: 'hidden',
})

const closedMixin = (theme: Theme): CSSObject => ({
	zIndex: 999,
	border: 'none',
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: 300,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(0)})`,
})

const Drawer = styled(MuiDrawer, {
	shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
	width: drawerWidth,
	flexShrink: 0,
	whiteSpace: 'nowrap',
	display: 'flex',
	boxSizing: 'border-box',

	...(open && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
	}),
}))

export default function MiniDrawer({
	openNotifications,
	setOpenNotifications,
	countNotif,
	setCountNotif,
	notificationButtonRef,
}) {
	const notificationsRef = useRef(null)

	const handleClickOutside = event => {
		if (
			notificationsRef.current &&
			!notificationsRef.current.contains(event.target) &&
			(!notificationButtonRef.current ||
				!notificationButtonRef.current.contains(event.target))
		) {
			setOpenNotifications(false)
		}
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside)
		document.addEventListener('touchstart', handleClickOutside)
		document.addEventListener('touchend', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
			document.removeEventListener('touchstart', handleClickOutside)
			document.addEventListener('touchend', handleClickOutside)
		}
	}, [notificationsRef])

	return (
		<>
			<CssBaseline />
			<Drawer
				variant='permanent'
				anchor='left'
				open={openNotifications}
				sx={{ border: 'none' }}
			>
				<Box
					sx={{
						height: '100vh',
						backgroundColor: COLORS.background,
						// backdropFilter: 'blur(11px)',
						overflow: openNotifications ? 'auto' : 'hidden',
						overscrollBehavior: 'contain',
						overflowX: 'hidden',
						'&::-webkit-scrollbar': {
							width: 4,
						},
						'&::-webkit-scrollbar-track': {
							backgroundColor: '#DBDBDB',
							borderRadius: 12,
						},
						'&::-webkit-scrollbar-thumb': {
							backgroundColor: COLORS.icon,
							borderRadius: 12,
						},
					}}
				>
					<Box ref={notificationsRef}>
						<NotificationsContent
							open={openNotifications}
							countNotif={countNotif}
							setCountNotif={setCountNotif}
							setOpenNotifications={setOpenNotifications}
						/>
					</Box>
				</Box>
			</Drawer>
		</>
	)
}
